import {
  ChangeDetectionStrategy,
  Component,
  ComponentFactoryResolver,
  DestroyRef,
  ElementRef,
  Renderer2,
  ViewChild,
  ViewContainerRef,
  computed,
  effect,
  inject,
  signal,
} from "@angular/core";

import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  ValidatorFn,
  Validators,
} from "@angular/forms";

import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";

import { filter, map } from "rxjs/operators";

import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

import { toSignal } from "@angular/core/rxjs-interop";

import { Canonical_URL } from "app/metacontent";

import { NgxSpinnerService } from "ngx-spinner";

import Swal from "sweetalert2";

import { Agent, User } from "@models/user";

import { LoginService } from "@services/auth.service";
import { CommonService } from "@services/common.service";
import { RegistrationService } from "@services/registration.service";
import { SharedService } from "@services/shared.service";
import { YTBSEOService } from "@services/ytb-seo.service";

import { B2C_LOOKUP } from "../../lookup-config";

import { MustMatch } from "../sign-up/customvalidation/mustmatchvalidation";

import {
  DialogService,
  DynamicDialogModule,
  DynamicDialogRef,
} from "primeng/dynamicdialog";

// declare var JSEncrypt: any;

@Component({
  selector: "app-usersignup",
  templateUrl: "./usersignup.component.html",
  styleUrls: ["./usersignup.component.css"],
  providers: [DynamicDialogModule, DialogService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserSignupComponent {
  /*
   * --------------------------------------------------------------------------
   * Angular 18 dependency injection
   * --------------------------------------------------------------------------
   */

  private readonly destroyRef = inject(DestroyRef);

  private readonly fb = inject(UntypedFormBuilder);

  private readonly resolver = inject(ComponentFactoryResolver);

  private readonly commonservice = inject(CommonService);

  private readonly registerServc = inject(RegistrationService);

  private readonly elem = inject(ElementRef);

  private readonly renderer = inject(Renderer2);

  private readonly spinner = inject(NgxSpinnerService);

  private readonly route = inject(ActivatedRoute);

  private readonly sharedService = inject(SharedService);

  private readonly authService = inject(LoginService);

  private readonly ytbseo = inject(YTBSEOService);

  private readonly router = inject(Router);

  private readonly el = inject(ElementRef);

  public readonly dialogService = inject(DialogService);

  /*
   * --------------------------------------------------------------------------
   * Signal-backed existing component variables
   *
   * The public variable names remain exactly the same.
   *
   * This allows existing HTML such as:
   *
   *   submitted
   *   showFail
   *   isUserID
   *
   * to continue working without changing it to:
   *
   *   submitted()
   *   showFail()
   *   isUserID()
   * --------------------------------------------------------------------------
   */

  private readonly submittedSignal = signal(false);

  get submitted(): boolean {
    return this.submittedSignal();
  }

  set submitted(value: boolean) {
    this.submittedSignal.set(value);
  }

  private readonly showSuccessSignal = signal(false);

  get showSuccess(): boolean {
    return this.showSuccessSignal();
  }

  set showSuccess(value: boolean) {
    this.showSuccessSignal.set(value);
  }

  private readonly isUserIDSignal = signal(false);

  get isUserID(): boolean {
    return this.isUserIDSignal();
  }

  set isUserID(value: boolean) {
    this.isUserIDSignal.set(value);
  }

  private readonly showFailSignal = signal(false);

  get showFail(): boolean {
    return this.showFailSignal();
  }

  set showFail(value: boolean) {
    this.showFailSignal.set(value);
  }

  private readonly isNavigateSignal = signal(false);

  get isNavigate(): boolean {
    return this.isNavigateSignal();
  }

  set isNavigate(value: boolean) {
    this.isNavigateSignal.set(value);
  }

  private readonly showAgentFormSignal = signal(false);

  get showAgentForm(): boolean {
    return this.showAgentFormSignal();
  }

  set showAgentForm(value: boolean) {
    this.showAgentFormSignal.set(value);
  }

  private readonly displaySignupSignal = signal(true);

  get displaySignup(): boolean {
    return this.displaySignupSignal();
  }

  set displaySignup(value: boolean) {
    this.displaySignupSignal.set(value);
  }

  private readonly isDisabledSignal = signal(false);

  get isDisabled(): boolean {
    return this.isDisabledSignal();
  }

  set isDisabled(value: boolean) {
    this.isDisabledSignal.set(value);
  }

  /*
   * userType is also signal-backed while preserving the existing
   * userType variable name.
   */

  private readonly userTypeSignal = signal<"user" | "agent">("user");

  get userType(): "user" | "agent" {
    return this.userTypeSignal();
  }

  set userType(value: "user" | "agent") {
    this.userTypeSignal.set(value);
  }

  /*
   * --------------------------------------------------------------------------
   * Existing component variables
   * --------------------------------------------------------------------------
   */

  registrationForm: UntypedFormGroup;

  required: any;

  countrydrop: Array<any>;

  countrycodes: Array<any>;

  lookup = B2C_LOOKUP;

  country_code: string;

  @ViewChild("isNavigated")
  isNavigated: ElementRef;

  @ViewChild(`signin`, { read: ElementRef })
  private signin: ElementRef;

  @ViewChild("signincontainer", { read: ViewContainerRef })
  private signincontainer: ViewContainerRef;

  queryparamsInfo: any = {};

  redirectUrl: string = "";

  errorMessageText: Array<string> = [];

  successMessageText: Array<string> = [];

  maxDate: Date;

  key: string;

  ytbuser: any;

  geoCode: any;

  dateOfBirthNotInFormat: boolean;

  livingInCountryCode: any;

  organizationTypes = [];

  agentForm: UntypedFormGroup;

  stateList1 = [];

  stateList2 = [];

  countriesList = [];

  stateSequence: string;

  requestId: string;

  queryParamsInfo: any;

  ref: DynamicDialogRef | undefined;

  /*
   * --------------------------------------------------------------------------
   * Angular 18 signal state
   * --------------------------------------------------------------------------
   */

  /**
   * Current router URL.
   *
   * This gives us a reactive URL state instead of repeatedly evaluating
   * router.url manually.
   */
  private readonly currentUrl = signal(this.router.url);

  /**
   * Derived state.
   *
   * Your original flight URL condition appeared several times.
   * It is now calculated once reactively.
   */
  readonly isFlightFlow = computed(() => {
    const url = this.currentUrl();

    return (
      url.includes("search/flights") ||
      url.includes("lp/flights") ||
      url.includes("flight-details") ||
      url.includes("book/flight") ||
      url.includes("coupons")
    );
  });

  /**
   * Signal representation of signup redirect URL.
   *
   * Existing redirectUrl variable is intentionally retained.
   */
  readonly signupRedirectUrl = toSignal(this.sharedService.signupRedirectUrl$, {
    initialValue: "",
  });

  /**
   * Signal representation of GeoLocationParam$.
   *
   * Existing geoCode and livingInCountryCode variables are retained.
   */
  readonly geoLocationParam = toSignal(this.sharedService.GeoLocationParam$, {
    initialValue: null,
  });

  /*
   * --------------------------------------------------------------------------
   * Constructor intentionally removed.
   *
   * Angular 18 inject() is used above.
   * Existing variable names are preserved.
   * --------------------------------------------------------------------------
   */

  constructor() {
    /*
     * This constructor is intentionally empty.
     *
     * Keeping the constructor means existing inheritance/metadata behavior
     * remains safe while all dependencies are now resolved using inject().
     */
  }

  /*
   * --------------------------------------------------------------------------
   * Initialization
   * --------------------------------------------------------------------------
   */

  ngOnInit(): void {
    /*
     * Keep router queryParams subscription because this component performs
     * existing side effects based on query parameters.
     */
    this.route.queryParams
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((param) => {
        this.currentUrl.set(this.router.url);

        const url = this.router.url.split("?");

        setTimeout(() => {
          this.ytbseo.createCanonicalURL(this.router.url);
          this.ytbseo.setDynamicTitle(url[0]);
        }, 3000);
      });

    /*
     * ------------------------------------------------------------------------
     * Agent form
     * ------------------------------------------------------------------------
     */

    this.agentForm = this.fb.group({
      orgcode: new UntypedFormControl(),

      rmId: new UntypedFormControl(),

      orgRoleCodeId: new UntypedFormControl(),

      UserId: new UntypedFormControl("", [
        Validators.required,

        Validators.pattern("^[a-zA-Z0-9 !@#$%^&*()-_=+\"|;:`~',<.>?/{}]+$"),

        this.userIdspaceValidator.bind(this),
      ]),

      FirstName: new UntypedFormControl("", [
        Validators.required,

        Validators.minLength(3),

        Validators.pattern("[ a-zA-Z][a-zA-Z ]+[a-zA-Z ]$"),

        this.spaceValidator.bind(this),
      ]),

      MiddleName: new UntypedFormControl("", [
        Validators.minLength(3),

        Validators.pattern("[ a-zA-Z][a-zA-Z ]+[a-zA-Z ]$"),

        this.spaceValidator.bind(this),
      ]),

      LastName: new UntypedFormControl("", [
        Validators.required,

        Validators.minLength(3),

        Validators.pattern("[ a-zA-Z][a-zA-Z ]+[a-zA-Z ]$"),

        this.spaceValidator.bind(this),
      ]),

      PhoneNumber: new UntypedFormControl("", [
        Validators.required,

        Validators.minLength(5),

        Validators.pattern("^[1-9][0-9]*$"),
      ]),

      dob: new UntypedFormControl(null, [
        Validators.required,

        Validators.minLength(10),

        this.ageValidator().bind(this),

        this.commonservice.validateDate,
      ]),

      phoneCodeiso2: new UntypedFormControl("", [Validators.required]),

      Password: new UntypedFormControl("", [
        Validators.required,

        Validators.minLength(6),

        Validators.pattern(
          "((?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%]).{6,})",
        ),
      ]),

      Email: new UntypedFormControl("", [
        Validators.required,

        Validators.email
      ]),

      Confirmpassword: new UntypedFormControl("", [Validators.required]),

      AcceptTerms: new UntypedFormControl(""),

      IdDocs: new UntypedFormControl(""),

      Address: this.initAddress("agentAddress"),

      Organization: this.initOrganization(),
    });

    /*
     * ------------------------------------------------------------------------
     * Registration form
     * ------------------------------------------------------------------------
     */

    this.registrationForm = this.fb.group(
      {
        countryiso2: new UntypedFormControl(),

        UserId: new UntypedFormControl("", [
          Validators.required,

          Validators.pattern("^[a-zA-Z0-9 !@#$%^&*()-_=+\"|;:`~',<.>?/{}]+$"),

          this.userIdspaceValidator.bind(this),
        ]),

        FirstName: new UntypedFormControl("", [
          Validators.required,

          Validators.minLength(3),

          Validators.pattern("[ a-zA-Z][a-zA-Z ]+[a-zA-Z ]$"),

          this.spaceValidator.bind(this),
        ]),

        MiddleName: new UntypedFormControl("", [
          Validators.minLength(3),

          Validators.pattern("[ a-zA-Z][a-zA-Z ]+[a-zA-Z ]$"),

          this.spaceValidator.bind(this),
        ]),

        LastName: new UntypedFormControl("", [
          Validators.required,

          Validators.minLength(3),

          Validators.pattern("[ a-zA-Z][a-zA-Z ]+[a-zA-Z ]$"),

          this.spaceValidator.bind(this),
        ]),

        PhoneNumber: new UntypedFormControl("", [
          Validators.minLength(5),

          Validators.pattern("^[1-9][0-9]*$"),
        ]),

        dob: new UntypedFormControl(null, [
          Validators.required,

          Validators.minLength(10),

          this.ageValidator().bind(this),

          this.commonservice.validateDate,
        ]),

        phoneCodeiso2: new UntypedFormControl(""),

        phoneCodeiso22: new UntypedFormControl(""),

        Password: new UntypedFormControl("", [
          Validators.required,

          Validators.minLength(6),

          Validators.pattern(
            "((?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%]).{6,})",
          ),
        ]),

        Email: new UntypedFormControl("", [
          Validators.required,

          Validators.email,
        ]),

        Confirmpassword: new UntypedFormControl("", [Validators.required]),

        AcceptTerms: new UntypedFormControl("", [Validators.required]),

        IdDocs: new UntypedFormControl(""),

        Address: this.initAddress("orgAddress"),

        Organization: this.initOrganization(),
      },
      {
        validator: MustMatch("Password", "Confirmpassword"),
      },
    );

    /*
     * ------------------------------------------------------------------------
     * Industry types
     * ------------------------------------------------------------------------
     */

    this.authService.getAllIndustryTypes();

    this.authService.GetIndustryTypesSuccess.pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((params) => {
      console.log(params, "  Inside of Agent component 82 ");

      if (params) {
        this.organizationTypes = [
          {
            id: "",
            industryType: "--Select--",
          },

          ...params.result,
        ];
      }
    });

    this.maxDate = new Date();

    this.initUserForm();

    this.getCountrycode();

    /*
     * ------------------------------------------------------------------------
     * Existing redirect URL subscription
     *
     * Retained because redirectUrl is an existing public variable.
     * ------------------------------------------------------------------------
     */

    this.sharedService.signupRedirectUrl$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((redirectUrl) => {
        if (redirectUrl) {
          this.redirectUrl = redirectUrl;
        }
      });

    /*
     * ------------------------------------------------------------------------
     * Geo location
     * ------------------------------------------------------------------------
     */

    this.sharedService.GeoLocationParam$.pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((params) => {
      if (params) {
        this.livingInCountryCode = params.countryCode;
      }
    });

    /*
     * ------------------------------------------------------------------------
     * Countries
     * ------------------------------------------------------------------------
     */

    this.commonservice.countrySignupSuccess$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((countryRes) => {
        if (countryRes !== null && countryRes !== undefined) {
          this.countrydrop = this.commonservice.prepareDropdownResponse(
            countryRes.result,
            "countryName",
            "countryISO2",
          );

          this.countrycodes =
            this.commonservice.preparePhoneCodesDropdownResponse(
              countryRes.result,
              "countryName",
              "countryISO2",
              "countryImage",
              "countryPhoneCode",
              "countryISO3",
            );

          this.countrycodes = this.countrycodes.filter((item) => {
            return item.value !== "null";
          });

          const item = this.countrycodes.find(
            (x) => x.value === this.livingInCountryCode,
          );

          if (item) {
            this.registrationForm.controls["phoneCodeiso2"].setValue(
              item.value,
            );
          }

          if (this.livingInCountryCode) {
            // Existing behavior intentionally retained.
          }

          /*
           * ------------------------------------------------------------------
           * Agent/User selection based on URL
           * ------------------------------------------------------------------
           */

          if (this.isFlightFlow()) {
            this.userType = "agent";

            this.switchToUserOrAgent("user");
          } else {
            this.route.queryParams
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe((param) => {
                setTimeout(() => {
                  if (param && !this.isObjectEmpty(param)) {
                    this.requestId = param["userKey"];

                    console.log(this.requestId, "  nagaraju");

                    this.spinner.show();

                    this.commonservice.getUserSignupQueryParamsInfo(
                      this.requestId,
                    );
                  }

                  this.userType = "agent";

                  this.switchToUserOrAgent("user");
                });
              });
          }
        }
      });

    /*
     * ------------------------------------------------------------------------
     * Registration failure
     * ------------------------------------------------------------------------
     */

    this.registerServc.onFailure
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response) => {
        if (response) {
          this.spinner.hide();

          if (response.exceptionSource === "RegisterFailed") {
            this.commonservice.logError({
              logLevel: "Error page Navigation Before",

              message: "RegisterFailed From User Signup Component ",
            });

            this.router.navigate(["error"]);
          }
        }
      });

    /*
     * ------------------------------------------------------------------------
     * B2C Registration success
     * ------------------------------------------------------------------------
     */

    this.registerServc.RegistrationSuccess.pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((registerres) => {
      console.log(JSON.stringify(registerres), "   207");

      if (registerres && registerres.statusCode === 1) {
        this.spinner.hide();

        let mainMessage = "Email Confirmation Sent Successfully";

        let warningMessage =
          "We have sent you a Confirmation for your registered Email Address. Please Confirm Your Email By clicking the Link in your Email Address to Confirm your account";

        if (
          registerres?.messageInfo?.uiSuccessMessge &&
          registerres.messageInfo.uiSuccessMessge.length > 0
        ) {
          mainMessage = registerres.messageInfo.uiSuccessMessge[0];
        }

        if (
          registerres?.messageInfo?.uiWarningMessge &&
          registerres.messageInfo.uiWarningMessge.length > 0
        ) {
          warningMessage = registerres.messageInfo.uiWarningMessge[0];
        }

        this.sharedService.closeRefereFrom();

        setTimeout(() => {
          Swal.fire({
            imageUrl: "assets/images/envelope.png",

            title: mainMessage,

            allowOutsideClick: false,

            text: warningMessage,
          }).then((ok) => {
            if (this.isFlightFlow()) {
              return;
            }

            if (this.signin) {
              this.signin.nativeElement.click();
            }

            this.logIn();
          });

          this.registrationForm.reset();
        }, 500);
      } else if (registerres && registerres.statusCode === 0) {
        this.showFail = true;

        this.showSuccess = false;

        this.successMessageText = registerres.messageInfo.uiErrorMessage;

        this.spinner.hide();
      } else {
        this.spinner.hide();

        this.showFail = true;

        this.showSuccess = false;

        this.successMessageText.push(
          "Unable to Process your request at this time",
        );
      }
    });

    /*
     * ------------------------------------------------------------------------
     * B2B Registration success
     * ------------------------------------------------------------------------
     */

    this.registerServc.RegistrationB2BSuccess.pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((registerres) => {
      console.log(JSON.stringify(registerres), "   241");

      this.isDisabled = false;

      if (registerres && registerres.statusCode === 1) {
        this.spinner.hide();

        Swal.fire({
          imageUrl: "assets/images/envelope.png",

          title: "Email Confirmation Sent Successfully",

          allowOutsideClick: false,

          text: "We have sent you a Confirmation for your registered Email Address. Please Confirm Your Email By clicking the Link in your Email Address to Confirm your account",
        }).then((ok) => {
          this.agentForm.reset();

          if (this.isFlightFlow()) {
            return;
          }

          if (this.signin) {
            this.signin.nativeElement.click();
          }

          this.logIn();
        });

        this.registrationForm.reset();
      } else if (registerres && registerres.statusCode === 0) {
        this.showFail = true;

        this.showSuccess = false;

        this.successMessageText = registerres.messageInfo.uiErrorMessage;

        this.spinner.hide();
      } else {
        this.spinner.hide();

        this.showFail = true;

        this.showSuccess = false;

        this.successMessageText.push(
          "Unable to Process your request at this time",
        );
      }
    });

    /*
     * ------------------------------------------------------------------------
     * Login success
     * ------------------------------------------------------------------------
     */

    this.authService.LoginSuccess.pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((payload) => {
      if (
        payload !== undefined &&
        payload !== null &&
        payload.result !== undefined &&
        payload.result !== null &&
        payload.result !== "PI" &&
        payload.result !== "PU" &&
        payload.result !== "UI" &&
        payload.result.status &&
        payload.result.status !== "PUS"
      ) {
        this.spinner.hide();

        this.sharedService.setUserIdAfterLogin(payload.result.userName);

        this.sharedService.setLoginUserDetails(payload.result);

        this.sharedService.loginSuccess.next(true);
      }
    });

    /*
     * ------------------------------------------------------------------------
     * Encryption key
     * ------------------------------------------------------------------------
     */

    this.commonservice.keySuccess$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((key) => {
        if (key !== null && key !== undefined) {
          this.key = key.data;
        }
      });

    /*
     * ------------------------------------------------------------------------
     * Geo location
     *
     * This subscription is retained because geoCode and
     * livingInCountryCode are existing mutable variables.
     * ------------------------------------------------------------------------
     */

    this.sharedService.GeoLocationParam$.pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((geoCode) => {
      if (geoCode !== null && geoCode !== "" && geoCode !== undefined) {
        this.geoCode = geoCode;

        this.livingInCountryCode = geoCode.countryCode;
      }
    });

    /*
     * ------------------------------------------------------------------------
     * State list
     * ------------------------------------------------------------------------
     */

    this.commonservice.StateList.pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((res) => {
      if (res && res.result) {
        if (this.stateSequence === "state1") {
          this.stateList1 = res.result;
        } else {
          this.stateList2 = res.result;
        }
      }
    });

    /*
     * ------------------------------------------------------------------------
     * Signup query parameter response
     * ------------------------------------------------------------------------
     */

    this.commonservice.USERSIGNUPQUERYPARAMSGETSUCESS$.pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((res) => {
      if (res.result && res.result.requestObj) {
        this.spinner.hide();

        this.queryParamsInfo = JSON.parse(res.result.requestObj);

        console.log(JSON.stringify(this.queryParamsInfo), "   nagaraju");

        this.agentForm.controls["orgcode"].setValue(
          this.queryParamsInfo?.orgcode,
        );

        this.agentForm.controls["orgRoleCodeId"].setValue(
          this.queryParamsInfo?.OrgRoleCodeId,
        );

        this.agentForm.controls["rmId"].setValue(this.queryParamsInfo?.RmId);

        this.agentForm.controls["Email"].setValue(this.queryParamsInfo?.Email);

        this.isDisabled = true;
      } else {
        this.spinner.hide();

        this.commonservice.logError({
          logLevel: "Error page Navigation Before",

          message:
            "Link Expired Contact Your Organization Manager to generate new link From User Signup Component ",
        });

        this.router.navigate(["error"], {
          queryParams: {
            module: "login",

            message: [
              "Link Expired Contact Your Organization Manager to generate new link",
            ],
          },
        });
      }
    });

    /*
     * Keep the signal in sync with the existing public redirectUrl.
     *
     * This effect is intentionally small. The existing subscription above
     * remains responsible for preserving current behavior.
     */
    effect(() => {
      const redirectUrl = this.signupRedirectUrl();

      if (redirectUrl) {
        this.redirectUrl = redirectUrl;
      }
    });
  }

  /*
   * --------------------------------------------------------------------------
   * Form getters
   * --------------------------------------------------------------------------
   */

  get f() {
    return this.registrationForm.controls;
  }

  get addressForm() {
    return this.agentForm.get("address") as UntypedFormGroup;
  }

  get agentAddress() {
    return this.agentForm.get("Address") as UntypedFormGroup;
  }

  get organization() {
    return this.agentForm.get("Organization") as UntypedFormGroup;
  }

  /*
   * --------------------------------------------------------------------------
   * UI methods
   * --------------------------------------------------------------------------
   */

  closePopUp(): void {
    this.displaySignup = !this.displaySignup;
  }

  ShowDropdown(event): boolean {
    return event.value.length >= 3;
  }

  allowOnlyChars(event: any): void {
    const pattern = new RegExp("^[a-zA-Z ]+$");

    const inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  allowOnlyNum(event): void {
    // Existing behavior retained.
  }

  /*
   * --------------------------------------------------------------------------
   * View initialization
   * --------------------------------------------------------------------------
   */

  ngAfterViewInit(): void {
    /*
     * Existing DOM behavior retained.
     *
     * The DOM manipulation is deliberately not moved to an Angular rendering
     * hook because changing its timing could affect existing layout behavior.
     */

    if (this.isNavigate) {
      if (
        this.isNavigated.nativeElement.classList.contains("col-12") &&
        this.isNavigated.nativeElement.classList.contains("col-lg-8")
      ) {
        this.renderer.removeClass(this.isNavigated.nativeElement, "col-12");

        this.renderer.removeClass(this.isNavigated.nativeElement, "col-lg-8");

        this.renderer.addClass(this.isNavigated.nativeElement, "col-md-12");
      } else {
        this.renderer.removeClass(this.isNavigated.nativeElement, "col-md-12");

        this.renderer.addClass(this.isNavigated.nativeElement, "col-12");

        this.renderer.addClass(this.isNavigated.nativeElement, "col-lg-8");
      }
    }
  }

  /*
   * --------------------------------------------------------------------------
   * Scrolling
   * --------------------------------------------------------------------------
   */

  scrollTo(el: Element): void {
    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }

  scrollToError(): void {
    const firstElementWithError = document.querySelector(
      ".ng-invalid[formControlName]",
    );

    this.scrollTo(firstElementWithError);

    console.log(this.agentForm.controls);

    for (const key of Object.keys(this.agentForm.controls)) {
      console.log(this.agentForm.controls[key]);

      if (this.agentForm.controls[key].invalid) {
        const invalidControl = this.el.nativeElement.querySelector(
          '[formcontrolname="' + key + '"]',
        );

        console.log(invalidControl);

        break;
      }
    }
  }

  /*
   * --------------------------------------------------------------------------
   * B2C registration
   * --------------------------------------------------------------------------
   */

  onSubmit(): void {
    this.submitted = true;

    this.showFail = false;

    this.showSuccess = false;

    this.successMessageText = [];

    if (this.registrationForm.valid && !this.isUserID) {
      this.spinner.show();

      const user = new User();

      user.loggedin_Country = this.geoCode.countryCode;

      const dateOfBirth = this.registrationForm.controls["dob"].value;

      const userObj = user.assignFormObj(this.registrationForm.value);

      userObj.dob = this.commonservice.getDateAddFromString(dateOfBirth, "-");

      userObj.userType = 0;

      userObj.userTypeStr = "User";

      userObj.countryiso2 =
        this.registrationForm.controls["phoneCodeiso2"].value;

      userObj.phoneCodeiso2 =
        this.registrationForm.controls["phoneCodeiso2"].value;

      this.spinner.show();

      this.ytbuser = userObj;

      this.ytbuser && this.ytbuser["Confirmpassword"]
        ? delete this.ytbuser["Confirmpassword"]
        : true;

      /*
       * Existing encryption/API behavior retained.
       */

      this.ytbuser.Password = this.commonservice.encryptData(
        JSON.stringify(this.ytbuser.Password),
        this.key,
      );

      this.registerServc.register(this.ytbuser);
    } else {
      this.commonservice.validateAllFormFields(this.registrationForm);

      this.registrationForm.markAllAsTouched();

      this.scrollToError();
    }

    /*
     * Focus first invalid control.
     */

    for (const key of Object.keys(this.registrationForm.controls)) {
      if (this.registrationForm.controls[key].invalid) {
        const invalidControl = this.el.nativeElement.querySelector(
          '[formcontrolname="' + key + '"]',
        );

        if (invalidControl) {
          invalidControl.focus();
        }

        break;
      }
    }
  }

  /*
   * --------------------------------------------------------------------------
   * Age validator
   * --------------------------------------------------------------------------
   */

  ageValidator(): ValidatorFn {
    return (
      control: AbstractControl,
    ): {
      [key: string]: boolean;
    } | null => {
      const birthdate = control.value;

      const dob = new Date(birthdate);

      const dateToCompare = new Date();

      const numberOfDaysToAdd = Math.ceil(
        (dateToCompare.getFullYear() - dob.getFullYear()) / 4,
      );

      dateToCompare.setDate(dateToCompare.getDate() - numberOfDaysToAdd);

      const dobOnly = new Date(
        dob.getFullYear(),
        dob.getMonth(),
        dob.getDate(),
      ).getTime();

      const dateToCompareOnly = new Date(
        dateToCompare.getFullYear(),
        dateToCompare.getMonth(),
        dateToCompare.getDate(),
      ).getTime();

      const age = (dateToCompareOnly - dobOnly) / (365 * 24 * 60 * 60 * 1000);

      const psgrage = age;

      if (psgrage > 100) {
        return {
          age: true,
        };
      }

      return null;
    };
  }

  /*
   * --------------------------------------------------------------------------
   * Date of birth
   * --------------------------------------------------------------------------
   */

  dateOfBirthDate(event): void {
    const currentCode = event.which;

    const currentKey = event.key;

    const dateOfBirth =
      this.userType === "user"
        ? this.registrationForm.controls["dob"]?.value?.toString()
        : this.agentForm.controls["dob"]?.value?.toString();

    if (event.key !== "Unidentified") {
      if (!isNaN(event.key)) {
        if (
          [46, 8, 9, 27, 13].indexOf(event.keyCode) !== -1 ||
          (event.keyCode === 65 && event.ctrlKey === true) ||
          (event.keyCode === 67 && event.ctrlKey === true) ||
          (event.keyCode === 86 && event.ctrlKey === true) ||
          (event.keyCode === 88 && event.ctrlKey === true) ||
          (event.keyCode === 65 && event.metaKey === true) ||
          (event.keyCode === 67 && event.metaKey === true) ||
          (event.keyCode === 86 && event.metaKey === true) ||
          (event.keyCode === 88 && event.metaKey === true) ||
          (event.keyCode >= 35 && event.keyCode <= 39)
        ) {
          return;
        }

        if (
          (event.shiftKey || event.keyCode < 48 || event.keyCode > 57) &&
          (event.keyCode < 96 || event.keyCode > 105)
        ) {
          event.preventDefault();
        } else {
          if (dateOfBirth) {
            this.setDateOfBirthToForm(event, dateOfBirth);
          }
        }
      } else {
        event.preventDefault();
      }
    } else {
      if (dateOfBirth) {
        const lastValue = dateOfBirth.substring(dateOfBirth.length - 1);

        if (!isNaN(lastValue) && event.keyCode > 105) {
          this.setDateOfBirthToForm(event, dateOfBirth);
        } else {
          const lastValue1 = dateOfBirth.substring(0, dateOfBirth.length - 1);

          this.registrationForm.controls["dob"].setValue(lastValue1);
        }
      }
    }
  }

  checkWheatherStrinHasValidSlashOrNot(value: string): void {
    if (value.length <= 3 && value.length <= 6) {
      value.substr(1, 2);
    }

    if (value.length <= 3) {
      // Existing behavior retained.
    }

    if (value.length <= 3) {
      // Existing behavior retained.
    }
  }

  setDateOfBirthToForm(event, dob): void {
    const pattern = /^([0-9]{2})-([0-9]{2})-([0-9]{4})$/;

    const date = new Date();

    let newDateFormat = "";

    if (date.getMonth() < 10) {
      newDateFormat += "0" + date.getMonth();
    } else {
      newDateFormat += date.getMonth();
    }

    if (dob.length === 3 && event.keyCode !== 8) {
      if (dob[2] !== "/") {
        dob = dob.substring(0, 2) + "/" + dob.substring(2, dob.length);
      }
    }

    if (dob.length === 6 && event.keyCode !== 8) {
      if (dob[5] !== "/") {
        dob = dob.substring(0, 5) + "/" + dob.substring(5, dob.length);
      }
    }

    if (dob.length === 2 && event.keyCode !== 8) {
      dob += "/";
    } else if (
      dob.length === 10 &&
      dob.substring(6, 10) === date.getFullYear() &&
      dob.substring(0, 2) > newDateFormat
    ) {
      // Existing behavior retained.
    } else if (dob.length === 2 && dob > 12) {
      // Existing behavior retained.
    }

    if (dob.length === 5 && event.keyCode !== 8) {
      dob += "/";
    } else if (dob.length === 5 && dob.substring(3, 5) > 31) {
      // Existing behavior retained.
    }

    if (dob.length === 10) {
      // Existing behavior retained.
    }

    if (this.userType === "user") {
      this.registrationForm.controls["dob"].setValue(dob);
    } else {
      this.agentForm.controls["dob"].setValue(dob);
    }
  }

  /*
   * --------------------------------------------------------------------------
   * Cleanup
   * --------------------------------------------------------------------------
   */

  ngOnDestroy(): void {
    /*
     * Important:
     *
     * takeUntilDestroyed() handles Angular subscription cleanup.
     *
     * This service-specific dispose() is retained because it is application
     * behavior and should not be removed merely because Angular 18 provides
     * DestroyRef.
     */

    this.registerServc.dispose();
  }

  /*
   * --------------------------------------------------------------------------
   * Custom validators
   * --------------------------------------------------------------------------
   */

  spaceValidator(dateOfBirthVal: AbstractControl) {
    const nameValue = dateOfBirthVal.value;

    if (nameValue) {
      if (nameValue) {
        const indexValue = nameValue.indexOf("  ");

        if (indexValue >= 0) {
          return {
            space: true,
          };
        } else {
          return null;
        }
      }
    }

    return null;
  }

  userIdspaceValidator(dateOfBirthVal: AbstractControl) {
    const nameValue = dateOfBirthVal.value;

    if (nameValue) {
      if (nameValue) {
        const indexValue = nameValue.indexOf(" ");

        if (indexValue >= 0) {
          return {
            userIdSpace: true,
          };
        } else {
          return null;
        }
      }
    }

    return null;
  }

  /*
   * --------------------------------------------------------------------------
   * User ID
   * --------------------------------------------------------------------------
   */

  checkUserIDExist(): void {
    this.isUserID = false;

    this.errorMessageText = [];

    const userIdControl =
      this.userType === "user"
        ? this.registrationForm.controls["UserId"]
        : this.agentForm.controls["UserId"];

    const userid =
      this.userType === "user"
        ? this.registrationForm.controls["UserId"].value
        : this.agentForm.controls["UserId"].value;

    if (userIdControl.valid && userid) {
      this.registerServc.getUserId({
        userId: userid.trim(),
      });

      /*
       * Existing API call is unchanged.
       *
       * takeUntilDestroyed() guarantees cleanup when this component is
       * destroyed.
       */

      this.registerServc.UserIDFinder.pipe(
        takeUntilDestroyed(this.destroyRef),
      ).subscribe((res) => {
        if (res && res.statusCode == 0) {
          this.errorMessageText = res.messageInfo.uiErrorMessage;

          this.isUserID = true;
        } else if (res && res.statusCode == 1) {
          this.isUserID = false;
        }
      });
    }
  }

  /*
   * --------------------------------------------------------------------------
   * Countries
   * --------------------------------------------------------------------------
   */

  countriesDropdown(): void {
    this.commonservice.getSignupCountries();
  }

  getCountrycode(): void {
    this.commonservice.getSignupCountries();
  }

  /*
   * --------------------------------------------------------------------------
   * Login
   * --------------------------------------------------------------------------
   */

  logIn(): void {
    this.closePopUp();

    this.sharedService.navigateToSigninFromSignup(true);
  }

  /*
   * --------------------------------------------------------------------------
   * Reset UI state
   * --------------------------------------------------------------------------
   */

  checkVal(): void {
    this.errorMessageText = [];

    this.isUserID = false;

    this.showFail = false;

    this.showSuccess = false;

    this.successMessageText = [];
  }

  /*
   * --------------------------------------------------------------------------
   * Navigation
   * --------------------------------------------------------------------------
   */

  navigateToCoupons(): void {
    this.router.navigate(["/coupons"]);
  }

  /*
   * --------------------------------------------------------------------------
   * Existing initialization methods
   * --------------------------------------------------------------------------
   */

  initUserForm(): void {
    /*
     * Existing implementation intentionally retained as commented code
     * because this method currently performs no runtime work.
     */
  }

  initAgentRegistrationForm(): void {
    /*
     * Existing implementation intentionally retained as commented code
     * because this method currently performs no runtime work.
     */
  }

  /*
   * --------------------------------------------------------------------------
   * Address form
   * --------------------------------------------------------------------------
   */

  initAddress(addressType: "agentAddress" | "orgAddress") {
    return this.fb.group({
      street1: new UntypedFormControl(
        "",
        this.checkRequiredValidation(addressType),
      ),

      street2: new UntypedFormControl(""),

      country: new UntypedFormControl(
        "",
        this.checkRequiredValidation(addressType),
      ),

      state: new UntypedFormControl(""),

      city: new UntypedFormControl(
        "",
        this.checkRequiredValidation(addressType),
      ),

      zip: new UntypedFormControl(
        "",
        this.checkRequiredValidation(addressType),
      ),
    });
  }

  /*
   * --------------------------------------------------------------------------
   * Organization form
   * --------------------------------------------------------------------------
   */

  initOrganization() {
    return this.fb.group({
      name: new UntypedFormControl(""),

      type: new UntypedFormControl("NC"),

      license: new UntypedFormControl(""),

      logo: new UntypedFormControl(""),

      description: new UntypedFormControl(""),

      businessType: new UntypedFormControl(""),

      noOfEmployees: new UntypedFormControl(""),

      address: this.initAddress("orgAddress"),
    });
  }

  /*
   * --------------------------------------------------------------------------
   * User / Agent switch
   * --------------------------------------------------------------------------
   */

  switchToUserOrAgent(
    userType: "agent" | "user",
    fromHtml: boolean = false,
  ): void {
    if (fromHtml) {
      /*
       * Existing navigation behavior retained.
       */

      this.sharedService.navigateToAgentSignupFromSigning(true);
    } else {
      this.userType = userType;

      const countryCode = this.countrycodes?.find(
        (x) => x.value === this.livingInCountryCode,
      );

      console.log(countryCode, "  nagaraju");

      if (userType === "user") {
        /*
         * Existing behavior retained.
         */

        if (countryCode) {
          this.registrationForm.controls["phoneCodeiso2"].setValue(
            countryCode.value,
          );
        }
      } else {
        if (countryCode) {
          this.agentForm.controls["phoneCodeiso2"].setValue(countryCode.value);
        }
      }
    }
  }

  /*
   * --------------------------------------------------------------------------
   * Object helper
   * --------------------------------------------------------------------------
   */

  isObjectEmpty(obj): boolean {
    if (obj) {
      return Object.keys(obj).length === 0;
    } else {
      return true;
    }
  }

  /*
   * --------------------------------------------------------------------------
   * State
   * --------------------------------------------------------------------------
   */

  getStates(event, stateSequence: string): void {
    this.stateSequence = stateSequence;

    this.commonservice.getState(event.target.value);
  }

  /*
   * --------------------------------------------------------------------------
   * Agent registration
   * --------------------------------------------------------------------------
   */

  onAgentRegistrationSubmit(): void {
    this.submitted = true;

    this.showFail = false;

    this.showSuccess = false;

    this.successMessageText = [];

    console.log(
      this.isUserID,
      this.agentForm.controls["phoneCodeiso2"].value,
      "    ",
    );

    if (this.agentForm.valid && !this.isUserID) {
      const user = new Agent();

      user.countryiso2 = this.agentForm.controls["phoneCodeiso2"].value;

      user.loggedin_Country = this.geoCode.countryCode;

      const dateOfBirth = this.agentForm.controls["dob"].value;

      const agentFormObj = this.agentForm.value;

      if (agentFormObj.Organization.type) {
        agentFormObj.Organization.industryTypeId =
          this.organization.get("type").value["id"];

        if (this.organization.get("type").value["industryType"] === "Travel") {
          agentFormObj.Organization.license = "";
        }
      }

      agentFormObj.Organization.organizationAddress =
        agentFormObj.Organization.address;

      const userObj = user.assignFormObj(agentFormObj);

      userObj.dob = this.commonservice.getDateAddFromString(dateOfBirth, "-");

      userObj.userType = 1;

      userObj.userTypeStr = "Agent";

      userObj.userDetails = this.requestId;

      this.spinner.show();

      this.ytbuser = userObj;

      this.ytbuser.userAddress = agentFormObj.Address;

      console.log(userObj.address);

      console.log(this.ytbuser);

      console.log(JSON.stringify(agentFormObj));

      this.ytbuser.userAddress["address1"] = agentFormObj.Address.street1;

      this.ytbuser.userAddress["address2"] = agentFormObj.Address.street2;

      this.ytbuser.userAddress["zipCode"] = agentFormObj.Address.zip;

      this.ytbuser.Organization.noOfEmployees =
        this.ytbuser.Organization.noOfEmployees.toString();

      this.ytbuser.Organization.organizationAddress["address1"] =
        agentFormObj.Organization.address.street1;

      this.ytbuser.Organization.organizationAddress["address2"] =
        agentFormObj.Organization.address.street2;

      this.ytbuser.Organization.organizationAddress["zipCode"] =
        agentFormObj.Organization.address.zip;

      this.ytbuser && this.ytbuser["Confirmpassword"]
        ? delete this.ytbuser["Confirmpassword"]
        : true;

      /*
       * Existing object transformation retained.
       */

      delete this.ytbuser.Address;

      delete this.ytbuser.userAddress.street1;

      delete this.ytbuser.userAddress.street2;

      delete this.ytbuser.Organization.organizationAddress.street1;

      delete this.ytbuser.Organization.organizationAddress.street2;

      delete this.ytbuser.Organization.type;

      /*
       * Existing encryption behavior retained.
       */

      this.ytbuser.Password = this.commonservice.encryptData(
        JSON.stringify(this.ytbuser.Password),
        this.key,
      );

      console.log(JSON.stringify(this.ytbuser));

      /*
       * IMPORTANT:
       *
       * Existing API call unchanged.
       */

      this.registerServc.agentRegister(this.ytbuser);
    } else {
      this.commonservice.validateAllFormFields(this.agentForm);

      this.scrollToError();
    }
  }

  /*
   * --------------------------------------------------------------------------
   * Address validators
   * --------------------------------------------------------------------------
   */

  checkRequiredValidation(addressType: "agentAddress" | "orgAddress") {
    if (addressType === "agentAddress") {
      return [Validators.required];
    } else {
      return [];
    }
  }

  /*
   * --------------------------------------------------------------------------
   * Error handling
   * --------------------------------------------------------------------------
   */

  getError(control: AbstractControl | null, name: string): string | null {
    if (
      control &&
      control.touched &&
      control.errors &&
      control.errors["required"]
    ) {
      return `${name} is required.`;
    }

    if (control && control.errors && control.value) {
      if (control.errors["minlength"]) {
        const requiredLength = control.errors["minlength"].requiredLength;

        return `Please enter minimum ${requiredLength} characters`;
      } else if (control.errors["pattern"]) {
        return `${name} must be in valid format`;
      } else if (control.errors["space"]) {
        return `Only one space allows between the letters`;
      } else if (control.errors["dobInvalid"]) {
        return ` Age should be less than 100 years. Please enter a valid Date of Birth`;
      } else if (control.errors["mustmatch"]) {
        return `Passwords must match`;
      } else if (control.errors["email"]) {
        return `Please enter a valid email address`;
      } else if (control.errors["userIdSpace"]) {
        return `Spaces are not allowed in User ID`;
      }
    }

    return null;
  }
}
